<template>
	<div class="call">
		<back-to></back-to>
		<section class="visaorder-content">
			<h2>{{productList.ProductName}}</h2>
			<div class="visaorder-content_label">
				<label for="" v-for="(item,index) in productList.DDinfo">
					<font>{{item[0][0]}}</font>
					<p>{{item[1][0]}}</p>
				</label>
			</div>
			<div class="visaorder-content_chuxing">
				<h3>出游人信息</h3>
				<label for="" @click="travelerShow = true">
					<p>{{getTicketName != ''?getTicketName : '请选择联系人'}}</p>
					<font class="right-arrow"></font>
				</label>
			</div>
		</section>
		<section class="shuoming">
			<label for="">
				{{productList.Msg}}
			</label>
		</section>

		<section class="choiceBtn">
			<div class="choiceBtn-l" @click="passme">跳过</div>
			<div class="choiceBtn-r" @click="writeme">下一步</div>
		</section>
		<!-- 出行人信息 -->
		<van-popup class="orderPopupt" v-model="travelerShow" round position="bottom"
			@click-overlay="travelerShow = false">
			<div class="orderPopup-sure">
				<span @click="travelerShow = false">取消</span>
				<span @click="travelerShow = false">确认</span>
			</div>
			<div class="orderPopup-add">
				<span @click="$router.push({ path: '/visatraveler',query:{type:0}})">+新增</span>
			</div>
			<div class="orderPopup-list">
				<ul>
					<li v-for="(item,index) in travelerList" :key="index" @click="selectTravelers(index)">
						<img src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_07.png"
							@click.stop="edit(item)" alt="">
						<p>{{item.TravellerName}}</p>
						<span class="orderPopup-lists">
							<img v-if="item.checked"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_08.png"
								alt="">
							<font v-if="!item.checked" class="select-false"></font>
						</span>
					</li>
				</ul>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		Dialog,
		Toast
	} from 'vant'
	export default {
		name: 'call',
		components: {
			BackTo
		},
		data() {
			return {
				productList: [],
				travelerList: [],
				getTicketName: "",
				travelerShow: false,
				orderID: ''
			}
		},
		created() {
			this.orderID = this.$route.query.orderId
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getData()
			this.getTravelerList()
		},
		methods: {
			selectTravelers(e) {
				var selectLength = this.travelerList.filter(item => item.checked == true)
				if (selectLength < 1) {
					this.travelerList[e].checked = !this.travelerList[e].checked
				} else {
					var index = this.travelerList.findIndex(item => item.checked == true)
					this.travelerList[index].checked = !this.travelerList[index].checked
					this.travelerList[e].checked = !this.travelerList[e].checked
				}
				this.getTicketName = this.travelerList[e].TravellerName
			},
			getData() {
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/GetOrderTravellerList', {
						orderID: this.orderID
					}
				).then(res => {
					console.log(res)
					this.productList = res
				})
			},
			getTravelerList() {
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/GetContactsList', {
						'userID': this.userInfo.userId.toString()
					}
				).then(res => {
					for (let i = 0; i < res.TravellerList.length; i++) {
						res.TravellerList[i].checked = false
					}
					this.travelerList = res.TravellerList
				})
			},
			edit(e) {
				var data = JSON.stringify(e)
				this.$router.push({
					path: '/visatraveler',
					query: {
						object: data
					}
				})
			},
			passme() {
				var jsonData = {
					orderID: this.orderID,
					isComplete: false
				}
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/SetOrderStatus', jsonData
				).then(res => {
					this.$router.push({
						path: '/orderStatus',
						query: {
							orderId: this.orderID
						}
					})
				})
			},
			writeme() {
				if (this.getTicketName == '') {
					Toast("请选择联系人")
					return
				}

				var jsonData = {
					orderID: this.orderID
				}
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/SetOrderStatus', jsonData
				).then(res => {
					this.$router.push({
						path: '/orderStatus',
						query: {
							orderId: this.orderID
						}
					})
				})
			}
		}
	}
</script>

<style scoped>
	.visaorder-content {
		width: 100%;
		padding: 0 48px;
		box-sizing: border-box;
	}

	.visaorder-content h2 {
		font-size: 36px;
		padding-top: 26px;
	}

	.visaorder-content_label label {
		width: 100%;
		display: flex;
		align-items: center;
		font-weight: bold;
		color: #000;
		font-size: 28px;
		margin-top: 48px;
	}

	.visaorder-content_label font {
		font-size: 30px;
		color: #666;
		font-weight: normal;
		width: 40%;
	}

	.visaorder-content_label p {
		width: 60%;
	}

	.visaorder-content_chuxing {
		width: 100%;
		margin-top: 48px;
	}

	.visaorder-content_chuxing h3 {
		font-size: 35px;
		color: #000;
		margin: 4px 0;
		font-weight: normal;
	}

	.visaorder-content_chuxing label {
		display: flex;
		align-items: center;
		font-size: 30px;
		color: #666;
		background: #f6f6f6;
		height: 72px;
		padding: 0 24px;
		line-height: 72px;
		margin-top: 40px;
		width: 100%;
		box-sizing: border-box;
		justify-content: space-between;
	}

	.right-arrow {
		display: inline-block;
		width: 36px;
		height: 36px;
		position: relative;
	}

	.right-arrow::after {
		display: inline-block;
		content: " ";
		height: 18px;
		width: 18px;
		border-width: 4px 4px 0 0;
		border-color: #000;
		border-style: solid;
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position: absolute;
		top: 0;
		right: 6px;
		margin-top: 9px;
		border-top-width: 2px;
		border-right-width: 2px;
		border-bottom-width: 0px;
		border-left-width: 0px;
		border-top-color: rgb(0, 0, 0);
		border-right-color: rgb(0, 0, 0);
		border-bottom-color: rgb(0, 0, 0);
		border-left-color: rgb(0, 0, 0);
		border-top-style: solid;
		border-right-style: solid;
		border-bottom-style: solid;
		border-left-style: solid;
	}

	.visaorder-content_Message {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 48px;
	}

	.visaorder-content_Message h3 {
		font-size: 35px;
		color: #000;
		margin: 4px 0;
		font-weight: normal;
	}

	.visaorder-content_Message-remark {
		width: 85%;
		border: none;
		background: #f9f9f9;
		font-size: 24px;
	}

	.visaorder-content_Message-remark .van-cell {
		background: #f9f9f9;
		padding: 10px !important;
		line-height: 38px;
	}

	.shuoming {
		width: 100%;
		margin-top: 60px;
	}

	.shuoming label {
		font-size: 22px;
		color: #666;
		background: #fff2f0;
		padding: 15px 25px;
		display: inline-block;
		box-sizing: border-box;
	}

	.shuoming font {
		color: #759ef8;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
		flex: 1;
		justify-content: center;
	}

	.choiceBtn-r {
		background: #ff6d00;
		font-size: 28px;
		color: #fff;
		border: 0;

	}

	.choiceBtn-l {
		font-size: 28px;
		display: inline-block;
		box-sizing: border-box;
		color: #000;
	}


	.orderPopupt {
		width: 100%;
		padding: 30px 0;
		height: 600px;
	}

	.orderPopup-sure {
		display: flex;
		justify-content: space-between;
		width: 100%;
		font-size: 30px;
		border-bottom: 1px solid #f2f2f2;
		padding: 0 70px 30px 70px;
		box-sizing: border-box;
	}

	.orderPopup-sure span:first-child {
		color: #ccc;
	}

	.orderPopup-sure span:last-child {
		color: #ff6d00;
	}

	.orderPopup-add {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.orderPopup-add span {
		margin-top: 30px;
		background: #f5f5f5;
		height: 80px;
		font-size: 40px;
		color: #ff6d00;
		text-align: center;
		line-height: 80px;
		border-radius: 5px;
		width: 100%;
	}

	.orderPopup-list {
		width: 100%;
		padding: 10px 50px;
		box-sizing: border-box;
	}

	.orderPopup-list li {
		display: flex;
		align-items: center;
		border-bottom: #f5f5f5 solid 1px;
		font-size: 30px;
		color: #333;
		height: 100px;

	}

	.orderPopup-list li p {
		margin-left: 30px;
	}

	.orderPopup-list img {
		width: 28px;
		height: 28px;
	}

	.select-false {
		display: block;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.orderPopup-lists {
		margin-left: auto;
	}
</style>
